import { Reviewer, User } from 'hooks/types/types';
import React from 'react';

export type UnderwritingDetailsProps = {
  trackId: string;
  trackHistoryUrl: string;
  uwRuleVersion: string;
  applicationSpecialist: Reviewer;
  ownersEndingEquity: string;
  totalEndingEquity: string;
  hasRentalResidentialType: boolean;
  underwriter?: Reviewer;
  htLienPosition: number | null;
  principalPaydown: number | null;
  totalPaydown: number | null;
  maximumInvestmentAmount: number | null;
  beginningHomeValuationLabel: string;
  beginningHomeValuationExpStatus: string;
  beginningHomeValuation: number | null;
  lienBalanceTotal: number | null;
  pastDueLienBalanceTotal: number | null;
  currentIncomeWeightedRiskBand: number | null;
  finalCompositeFico: number | null;
  highestSingleYearDelinquentTaxes: string | null;
  rb6Criteria: number | null;
  latestUwCalculatorOutput?: UnderwritingCalculatorOutputNode | null;
  enabledFinalApprovalBlockingErrors: boolean;
  finalApprovalBlockingErrors?: string[] | null;
  trackReviewStatus?: string;
  lossThreshold?: number | null;
  shareUp?: number | null;
  shareDown?: number | null;
  applicationIsApprovedOrClosedLost?: boolean;
  uwDscr?: number | null;
  thirdLienCap?: number | null
  refetch?: () => void;
  refetchFinalApprovalBlockingErrorsData?: () => void;
};

export type UnderwritingCalculatorOutputNode = {
  identifier: string;
  createdAt: string;
  eligibilityStatus?: boolean;
  allFailedCriteriaDetails?: string[];
  thirdLienCapApplied?: boolean | null;
};

export type DelinquentTaxesPopupProps = {
  highestSingleYearDelinquentTaxes: string | null;
  isEditable: boolean;
  trackId: string;
  refetch?: () => void;
};

export type RiskBandCriteriaPopupProps = {
  rb6Criteria: number | null;
  isEditable: boolean;
  trackId: string;
  refetch?: () => void;
};

export type StaffSelectPopupProps = {
  isAppSpecialist: boolean;
  initialStaff?: User;
  trackId: string;
  user: User;
  refetch?: () => void;
};

export enum HomeResidenceTypes {
  RESIDENCE_TYPE_UNKNOWN = 'un',
  RESIDENCE_TYPE_RENTAL = 're',
  RESIDENCE_TYPE_PRIMARY_RESIDENCE = 'pr',
  RESIDENCE_TYPE_VACATION = 'va',
}

export type BulletItem = {
  label: React.ReactNode;
  value: React.ReactNode;
};

type HomeValuation = {
  __typename: string;
  identifier: string;
  value: number;
  type: string;
  shortType: string;
  expirationDate: string;
  daysUntilExpires: number;
};

export type BeginningHomeValuation = HomeValuation | null;

export type GetDealTermsLeftItems = {
  maximumInvestmentAmount: number | null;
  beginningHomeValuation: number | null;
  beginningHomeValuationLabel: string;
  beginningHomeValuationExpStatus: string;
  lienBalanceTotal: number | null;
  pastDueLienBalanceTotal: number | null;
  ownersEndingEquity: string;
  totalEndingEquity: string;
};

export type GetOverviewItemsParams = {
  uwRuleVersion: string;
  applicationSpecialist: Reviewer;
  underwriter?: Reviewer;
  htLienPosition: number | null;
  principalPaydown: number | null;
  totalPaydown: number | null;
  rb6Criteria: any;
  enableFieldEditing: boolean;
  trackId: string;
  highestSingleYearDelinquentTaxes: string | null;
  hasRentalResidentialType: boolean;
  uwDscr?: number | null;
  user: User;
  refetchTrack?: () => void;
  refetchBlockers?: () => void;
};

export type DealTermsRightParams = {
  lossThreshold?: number | null;
  currentIncomeWeightedRiskBand?: number | null;
  finalCompositeFico?: number | null;
  shareUp?: number | null;
  shareDown?: number | null;
};
